/*
 * @Author: Assistant
 * @Date: 2025-12-20
 * @Description: AI Video Page 多语言配置
 * @FilePath: /weryai-web/locales/modules/aiVideo.ts
 */
export default {
    zh: {
        // 页面标题
        pageTitle: 'AI 视频生成',
        pageSubtitle: '使用最先进的 AI 模型，将您的创意转化为精彩视频',
        no_video_try_these: '没有视频？试试这些：',
        tools_banner:'示例',
        recommend_text:'推荐素材',
        do_similar_text:'做同款',
        elegant_lady:'优雅女士',
        sweet_girl:'甜美少女',
        gentleman:'魅力绅士',
        stage_star:'舞台之星',
    },
    en: {
        // Page title
        pageTitle: 'AI Video Generation',
        pageSubtitle: 'Transform your creativity into stunning videos with the most advanced AI models',
        no_video_try_these: 'No video? Try these:',
        tools_banner:'Sample',
        recommend_text:'Recommend Materials',
        do_similar_text:'Do Similar',
        elegant_lady:'Elegant Lady',
        sweet_girl:'Sweet Girl',
        gentleman:'Gentleman',
        stage_star:'Stage Star',

    },
    ja: {
        // ページタイトル
        pageTitle: 'AI ビデオ生成',
        pageSubtitle: '最先端のAIモデルで、創造性を素晴らしいビデオに変換',
        no_video_try_these: 'ビデオがない場合は、これらを試してください：',
        tools_banner: 'サンプル',
        recommend_text: 'おすすめ素材',
        do_similar_text: '同じスタイルで作る',
        elegant_lady:'優雅な女性',
        sweet_girl:'甘い少女',
        gentleman:'魅力ある紳士',
        stage_star:'舞台の星',
    },
    ko: {
        // 페이지 제목
        pageTitle: 'AI 비디오 생성',
        pageSubtitle: '가장 진보된 AI 모델로 창의성을 멋진 비디오로 변환',
        no_video_try_these: '비디오가 없으신가요? 이것들을 시도해보세요：',
        tools_banner: '샘플',
        recommend_text: '추천 소재',
        do_similar_text: '비슷하게 만들기',
        elegant_lady:'우아한 여성',
        sweet_girl:'달콤한 소녀',
        gentleman:'매력적인 남성',
        stage_star:'스테이지 스타',
    },
    tw: {
        // 頁面標題
        pageTitle: 'AI 影片生成',
        pageSubtitle: '使用最先進的 AI 模型，將您的創意轉化為精彩影片',
        no_video_try_these: '沒有影片？試試這些：',
        tools_banner: '範例',
        recommend_text: '推薦素材',
        do_similar_text: '做同款',
        elegant_lady:'優雅女士',
        sweet_girl:'甜美少女',
        gentleman:'魅力绅士',
        stage_star:'舞台之星',
    },
    pl: {
        // Page title
        pageTitle: 'Generowanie wideo AI',
        pageSubtitle:
            'Zamień swoją kreatywność w zachwycające wideo dzięki najnowocześniejszym modelom AI',
        no_video_try_these: 'Nie ma wideo? Spróbuj te:',
        tools_banner: 'Próbka',
        recommend_text: 'Polecane materiały',
        do_similar_text: 'Zrób podobne',
        elegant_lady: 'Elegancka Dama',
        sweet_girl: 'Słodka Dziewczyna',
        gentleman: 'Dżentelmen',
        stage_star: 'Gwiazda Sceny',
    },
    es: {
        // Título de la página
        pageTitle: 'Generación de Videos con IA',
        pageSubtitle: 'Transforma tu creatividad en videos impresionantes con los modelos de IA más avanzados',
        no_video_try_these: 'No hay video? Prueba estos:',
        tools_banner: 'Muestra',
        recommend_text: 'Materiales recomendados',
        do_similar_text: 'Hacer similar',
        elegant_lady: 'Dama Elegante',
        sweet_girl: 'Chica Dulce',
        gentleman: 'Caballero',
        stage_star: 'Estrella del Escenario',
    },
    fr: {
        // Titre de la page
        pageTitle: 'Génération de Vidéos IA',
        pageSubtitle: 'Transformez votre créativité en vidéos époustouflantes avec les modèles IA les plus avancés',
        no_video_try_these: 'Pas de vidéo ? Essayez ces:',
        tools_banner: 'Exemple',
        recommend_text: 'Matériaux recommandés',
        do_similar_text: 'Faire similaire',
        elegant_lady: 'Dame Élégante',
        sweet_girl: 'Fille Douce',
        gentleman: 'Gentleman',
        stage_star: 'Star de la Scène',
    },
    de: {
        // Seitentitel
        pageTitle: 'KI-Videoerzeugung',
        pageSubtitle: 'Verwandeln Sie Ihre Kreativität in beeindruckende Videos mit den fortschrittlichsten KI-Modellen',
        no_video_try_these: 'Kein Video? Versuche diese:',
        tools_banner: 'Beispiel',
        recommend_text: 'Empfohlene Materialien',
        do_similar_text: 'Ähnliches erstellen',
        elegant_lady: 'Elegante Dame',
        sweet_girl: 'Süßes Mädchen',
        gentleman: 'Gentleman',
        stage_star: 'Bühnenstar',
    },
    ru: {
        // Заголовок страницы
        pageTitle: 'Генерация Видео ИИ',
        pageSubtitle: 'Преобразуйте свои идеи в потрясающие видео с помощью самых передовых моделей ИИ',
        no_video_try_these: 'Нет видео? Попробуйте эти:',
        tools_banner: 'Образец',
        recommend_text: 'Рекомендуемые материалы',
        do_similar_text: 'Сделать похожее',
        elegant_lady: 'Элегантная Леди',
        sweet_girl: 'Милая Девушка',
        gentleman: 'Джентльмен',
        stage_star: 'Звезда Сцены',
    },
    pt: {
        // Título da página
        pageTitle: 'Geração de Vídeos com IA',
        pageSubtitle: 'Transforme sua criatividade em vídeos impressionantes com os modelos de IA mais avançados',
        no_video_try_these: 'Não há vídeo? Tente estes:',
        tools_banner: 'Amostra',
        recommend_text: 'Materiais recomendados',
        do_similar_text: 'Fazer similar',
        elegant_lady: 'Dama Elegante',
        sweet_girl: 'Garota Doce',
        gentleman: 'Cavalheiro',
        stage_star: 'Estrela do Palco',
    },
    it: {
        // Titolo della pagina
        pageTitle: 'Generazione di Video IA',
        pageSubtitle: 'Trasforma la tua creatività in video straordinari con i modelli IA più avanzati',
        no_video_try_these: 'Non c\'è video? Prova questi:',
        tools_banner: 'Esempio',
        recommend_text: 'Materiali consigliati',
        do_similar_text: 'Crea simile',
        elegant_lady: 'Signora Elegante',
        sweet_girl: 'Ragazza Dolce',
        gentleman: 'Gentiluomo',
        stage_star: 'Star del Palco',
    },
    ar: {
        // عنوان الصفحة
        pageTitle: 'إنشاء فيديو بالذكاء الاصطناعي',
        pageSubtitle: 'حوّل إبداعك إلى فيديوهات مذهلة باستخدام أكثر نماذج الذكاء الاصطناعي تقدمًا',
        no_video_try_these: 'ليس هناك فيديو؟ جرب هذه:',
        tools_banner: 'عينة',
        recommend_text: 'مواد موصى بها',
        do_similar_text: 'إنشاء مشابه',
        elegant_lady: 'سيدة أنيقة',
        sweet_girl: 'فتاة حلوة',
        gentleman: 'رجل نبيل',
        stage_star: 'نجم المسرح',
    },
    th: {
        // Page title
        pageTitle: 'การสร้างวิดีโอด้วย AI',
        pageSubtitle: 'เปลี่ยนความคิดสร้างสรรค์ของคุณให้เป็นวิดีโอสุดตระการตาด้วยโมเดล AI ที่ล้ำสมัยที่สุด',
        no_video_try_these: 'ไม่มีวิดีโอ? ลองที่นี่:',
        tools_banner: 'ตัวอย่าง',
        recommend_text: 'วัสดุแนะนำ',
        do_similar_text: 'ทำแบบเดียวกัน',
        elegant_lady: 'สุภาพสตรีสง่างาม',
        sweet_girl: 'สาวน่ารัก',
        gentleman: 'สุภาพบุรุษ',
        stage_star: 'ดาวบนเวที',
    },
    da: {
        // Page title
        pageTitle: 'AI‑videogenerering',
        pageSubtitle: 'Forvandl din kreativitet til imponerende videoer med de mest avancerede AI‑modeller',
        no_video_try_these: 'Ingen video? Prøv disse:',
        tools_banner: 'Prøve',
        recommend_text: 'Anbefalede materialer',
        do_similar_text: 'Lav lignende',
        elegant_lady: 'Elegant Dame',
        sweet_girl: 'Sød Pige',
        gentleman: 'Gentleman',
        stage_star: 'Scenestjerne',
    },
    no: {
        // Page title
        pageTitle: 'AI‑videogenerering',
        pageSubtitle: 'Gjør kreativiteten din om til imponerende videoer med de mest avanserte AI‑modellene',
        no_video_try_these: 'Ingen video? Prøv disse:',
        tools_banner: 'Eksempel',
        recommend_text: 'Anbefalte materialer',
        do_similar_text: 'Lag lignende',
        elegant_lady: 'Elegant Dame',
        sweet_girl: 'Søt Jente',
        gentleman: 'Gentleman',
        stage_star: 'Scenestjerne',
    },
    nl: {
        // Page title
        pageTitle: 'AI‑videogeneratie',
        pageSubtitle: "Zet je creativiteit om in indrukwekkende video's met de meest geavanceerde AI-modellen",
        no_video_try_these: 'Geen video? Probeer deze:',
        tools_banner: 'Voorbeeld',
        recommend_text: 'Aanbevolen materialen',
        do_similar_text: 'Maak vergelijkbaar',
        elegant_lady: 'Elegante Dame',
        sweet_girl: 'Lief Meisje',
        gentleman: 'Heer',
        stage_star: 'Podiumster',
    },
    id: {
        // Page title
        pageTitle: 'Generasi Video AI',
        pageSubtitle: 'Ubah kreativitas Anda menjadi video menakjubkan dengan model AI paling canggih',
        no_video_try_these: 'Tidak ada video? Coba ini:',
        tools_banner: 'Sampel',
        recommend_text: 'Materi Rekomendasi',
        do_similar_text: 'Buat Serupa',
        elegant_lady: 'Wanita Elegan',
        sweet_girl: 'Gadis Manis',
        gentleman: 'Pria Terhormat',
        stage_star: 'Bintang Panggung',
    },
    tr: {
        // Page title
        pageTitle: 'AI Video Üretimi',
        pageSubtitle: 'Yaratıcılığınızı en gelişmiş AI modelleriyle etkileyici videolara dönüştürün',
        no_video_try_these: 'Video yok? Bu deneyin:',
        tools_banner: 'Örnek',
        recommend_text: 'Önerilen Materyaller',
        do_similar_text: 'Benzerini Yap',
        elegant_lady: 'Zarif Bayan',
        sweet_girl: 'Tatlı Kız',
        gentleman: 'Beyefendi',
        stage_star: 'Sahne Yıldızı',
    },
}
